<template>
  <layout-basic>
    <page-hero
      title="Health & Safety"
      lead="Keep health and safety training organised and trackable."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="features" />
      </v-container>
    </section>

    <point-grid
      title="Make H&S learning visible and manageable"
      :points="points"
      :columns="2"
      tint
    />

    <standard-cta
      title="Ready to organise health & safety learning?"
      lead="Watch the 4-minute demo or experience IMPROVE and see how easy tracking can be."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'SolutionHealthSafety',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    StandardCta,
    DemoVideo,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Health & Safety Training | IMPROVE',
      description:
        'Keep health and safety training organised, trackable and easy to assign across your business.',
      path: '/solutions/health-and-safety',
    });
  },
  data() {
    return {
      points: [
        'Dedicated health & safety course library',
        'Assign role-specific H&S learning quickly',
        'Track completions for every site and team',
        'Upload your own risk assessments and procedures',
        'Certificates for completed training',
        'Clear reporting when you need evidence',
      ],
    };
  },
};
</script>
